<template>
  <div class="preview-dialog">
    <el-dialog
      title="预览"
      :visible.sync="previewDialogVisible"
      :before-close="dialogClose"
      width="750px"
    >
      <div class="table" v-if="ruleForm">
        <!-- <div class="title">
          {{ ruleForm.formName }}
        </div>
        <el-divider></el-divider> -->
        <el-form>
          <el-form-item
            v-for="(item, index) in questionList"
            :key="index"
            :label="index + 1 + '.' + item.questionDesc"
            :label-position="labelPosition"
            style="text-align: left"
          >
            <el-radio-group
              v-model="item.val"
              :disabled="disabled"
            >
              <el-radio
                v-for="(rItem, rIndex) in item.teacherEvaluationOptions"
                :key="rIndex"
                :label="rItem.optionDesc + '(' + rItem.score + '分)'"
                class="radio"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["previewDialogVisible", "ruleForm"],
  data() {
    return {
      disabled: false,
      labelPosition: "top",
      questionList: []
    };
  },
  mounted() {
    // console.log("questionList：", this.questionList);
  },
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:previewDialogVisible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./previewDialog.scss";
</style>